import React, { useState, useEffect } from "react";
import { cn } from "../../lib/utils";
import { GradFlow } from 'gradflow';

export const StripeLikeGradientShader = ({ className }) => {
  const [key, setKey] = useState(0);

  useEffect(() => {
    let timeoutId;
    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setKey(prev => prev + 1);
      }, 100);
    };
    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleResize);
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <div 
      className={cn("fixed inset-0 pointer-events-none", className)}
      style={{ 
        zIndex: -10,
        width: '100%', 
        height: '100%',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: 'hidden'
      }}
    >
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
        <GradFlow 
          key={key}
          config={{
            color1: { r: 255, g: 255, b: 255 },
            color2: { r: 66, g: 55, b: 233 },
            color3: { r: 129, g: 6, b: 190 },
            speed: 0.4,
            scale: 1,
            type: 'stripe',
            noise: 0.08
          }} 
        />
      </div>
    </div>
  );
};
